import { LevelType } from 'data/types';
import { isLevelConditioned } from 'utils/structure';
import { levelHasSpaces } from 'utils/structure-add-spaces';
import { sortLevelsByVerticalPosition } from 'utils/structure-basics';

export function getDefaultConditionedLevel(
  structure: LevelType[]
): LevelType | null {
  const orderedLevels = sortLevelsByVerticalPosition(structure);
  const conditionedLevels = orderedLevels.filter((level) =>
    isLevelConditioned(level)
  );
  return (
    conditionedLevels.find((level) => levelHasSpaces(level)) ??
    conditionedLevels[0] ??
    orderedLevels[0] ??
    null
  );
}

export function getDefaultConditionedLevelIndex(
  structure: LevelType[]
): number {
  const defaultLevel = getDefaultConditionedLevel(structure);
  if (!defaultLevel) {
    return 0;
  }
  const index = structure.findIndex(
    (level) => level.uniqueId === defaultLevel.uniqueId
  );
  return Math.max(index, 0);
}

export function getFirstConditionedLevelIndexInList(
  levels: LevelType[]
): number {
  const index = levels.findIndex((level) => isLevelConditioned(level));
  return Math.max(index, 0);
}
